import dynamic from "next/dynamic";

export const PromptModal = dynamic<{}>(
  () => import("./PromptModal").then((Module) => Module.PromptModal),
  { ssr: false }
);
